<lg-icon [icon]="requirement.passed ? 'icon-check' : 'icon-close'"></lg-icon>
<span>{{ ".CheckCodes." + requirement.lcCode | lgTranslate: { count: requirement.value } }}</span>
